<template>
  <img src="@/assets/logo.jpg" :height="height + 'px'" />
</template>

<script>
export default {
  props: {
    height: {
      type: [String, Number],
      default: "50"
    }
  }
}
</script>

<style>
</style>